import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Expose } from 'class-transformer';

export class ContactPerson extends DropdownModel {
  @Expose() id?: number;
  @Expose() name?: string = '';
  @Expose() firstName?: string = '';
  @Expose() lastName?: string = '';
  @Expose() mobileNumber?: string = '';
  @Expose() email?: string = '';
  @Expose() isDefault?: boolean = false;

  constructor() {
    super();
  }

   fullName?(): string {
    return this.firstName + ' ' + this.lastName;
  }

  get dropDownDisplayName(): string {
    return this.name ? this.name : (this.firstName + ' ' + this.lastName);
  }

  get dropDownValue(): Object {
    return this;
  }
}
